<template>
	<div class="justify-center max-w-6xl md:px-6 mx-auto mb-5">
		<div class="bg-red-800 py-4">
			<div class="flex flex-col items-center text-white">
				<p class="font-bold text-2xl">Terms and Conditions</p>
				<p>The following terms & conditions apply to all occasions where MVM received instructions to move a vehicle whether via telephone, call or email.</p>
			</div>
		</div>
	</div>
	<TitledSection
		v-for="(term, index) in terms"
		:key="index"
		:title="term.title"
		:text="term.text"
	/>
</template>

<script>
import TitledSection from '@/components/TitledSection.vue'

export default {
	name: 'T&Cs',
	components: {
		TitledSection,
	},
	data: function() {
		return {
			terms : [
				{
					title : 'Our Insurance',
					text: [
						'Every car driven by MVM or in our care is fully insured. Our Public Liability Insurance is £1,000,000 and our Fully Comprehensive Road Risk Policy provides cover for our designated team to drive any vehicle.'
					],
				},
				{
					title : 'MVM Drivers',
					text: [
						'All MVM drivers are interviewed personally by the management team and provided with full training. Each new driver is sent out with experienced colleague before completing movements solo. Our team are smartly presented in company uniform and equipped with trade plates at all times. MVM do not use agency or temporary staff.'
					],
				},
				{
					title : 'Vehicle collection, delivery & appraisal',
					text: [
						'All vehicles moved by MVM are subject to an exterior inspection & written damage report which both parties sign before a vehicle departs. Our drivers then request a signature confirming this vehicle condition on delivery. Once the vehicle has been inspected and signed in at the point of handover, MVM will have no further liability and cannot be held responsible for any future claims as to its cosmetic condition or road-worthiness.',
						'Vehicle appraisals are based on the opinions of the driver following a visual assessment of the condition of the vehicle and are subject to the light & weather conditions at the time of collection. They do not include a road test unless requested in writing at the time of booking.',
						'MVM have the capacity to carry out “MoDel Deliveries” where all appraisals & signatures are recorded along with photographic evidence on a hand-held PDA device. If you require a MoDel handover, please ensure this is requested at the time of booking.'
					],
				},
				{
					title : 'Damage in Transit',
					text: [
						'Motor trade insurance policies as standard do not cover punctures, glass damage or chips/damage from road debris. Incidents of this nature are deemed to be of no fault of MVM Logistics as they can occur regardless of the care taken by any driver. If you would like to insure your movement against damage of windscreen and tyres please inform the office via email at the time of booking. Charge £4.50 plus VAT.',
						'Where it is agreed that MVM are responsible for rectification of vehicle damage other than punctures, glass damage or chips from road debris, an independent estimate for repair is required and charges must be supported by a bone-fide invoice.'
					],
				},
				{
					title : 'Vehicle Breakdowns',
					text: [
						'It is the responsibility of the requesting client to ensure a vehicle is fully roadworthy, with valid MOT (if required), before requesting a driven movement. Where a breakdown occurs through no fault of an MVM driver, authorisation will be requested to obtain recovery quotes to a destination point of your choice. All recovery costs are the responsibility of the client and will be included as an addition to your invoice. Waiting time from point of breakdown until the vehicle is moving onward are charged at £12.50 + VAT / 30 min plus (if applicable) any additional transport costs to re-locate the driver to the original destination point.'
					],
				},
				{
					title : 'Late Arrivals',
					text: [
						'Our drivers are required to communicate any occasion where they are running behind schedule where time-scales have been agreed. Whilst MVM plan routings effectively, unforeseen incidents (traffic, accidents, road closures, public transport failures etc.) can cause delays. MVM will endeavour at all times to keep the customer / dealer fully informed of such delays.'
					],
				},
				{
					title : 'Waiting Time',
					text: [
						'Drivers are allocated 30 minutes to collect or deliver a vehicle at a dealership. Where a customer handover has been requested, drivers are allocated 60 minutes to complete a vehicle demonstration and paperwork. Waiting time is charged to the requesting dealer at a rate of £12.50 + VAT / 30 min wait after the initial 30 minutes. Charges are made due to the expense & knock on effects that delays have to a drivers scheduled jobs.'
					],
				},
				{
					title : 'Cancellation & Aborted journeys',
					text: [
						'Due to the necessity to plan & allocate driver workload in advance, any cancellation requests after 16.00hrs the day before or on the day a vehicle is scheduled to be moved will incur a full aborted movement charge equal to the original value of the quote. Where you are advised that the driver will be pre-booked onto a flight or ferry, a full aborted charge will apply for cancellation of the movement at anytime after your booking has been confirmed.'
					],
				},
				{
					title : 'Payment of Invoices',
					text: [
						'Where an account is held with us, MVM invoices are due no longer than 30 days after the job has been completed. Where an order number has been requested but not supplied, the invoice is still due on the due date.'
					],
				},
			]
		}
	}
}

</script>